<div class="promo-social-container">
  <div class="promo-video-wrapper">
    <div class="promo-block">
      <p class="promo-title">{{'PROMO.TITLE' | translate}}</p>

      <div class="feature-block">
        <p class="feature-title">{{'PROMO.OFFER' | translate}}</p>
        <ul class="feature-list">
          <li>{{'PROMO.OFFER_DESC_1' | translate}}</li>
        </ul>
        <p class="mt-2">{{'PROMO.DESC' | translate}}</p>
      </div>

      <p class="promo-notice"><b>{{'PROMO.NOTICE' | translate}} </b><i>{{'PROMO.NOTICE_DESC' | translate}}</i></p>

      <button type="button" class="btn btn-secondary" (click)="openMembershipModal()" *ngIf="!userHasMembership">{{'FOOTER.BECOME_MEMBER' | translate}}</button>
    </div>
  </div>

 <!--  <app-socials></app-socials> -->
</div>